import { getLastMonthDateRange } from '~/utils/date';
import { IFormValues } from '../types';

const getInitialValues = (): IFormValues => ({
  programIds: [],
  ...getLastMonthDateRange(),
});

export default getInitialValues;
